import React from "react";
import Menu from "./Menu";

const SecondaryMenu = ({ menuItems, logo, contactNumber }) => {
	return (
		<div className="relative bg-white">
			<div className="max-w-7xl mx-auto">
				<div className="relative z-10 bg-white lg:w-full">
					<Menu items={menuItems} logo={logo} contactNumber={contactNumber} />
				</div>
			</div>
		</div>
	);
};

export default SecondaryMenu;
